<div class="contact-layout-1" [style.background-color]="data?.backgroundColor || '#F3F9FC'">
  <div class="contact-header">
    <h2 class="contact-title" 
        [style.color]="headingColor || '#00435D'"
        [style.font-family]="headingFont || 'Plus Jakarta Sans, sans-serif'"
        [ngStyle]="titleStyles">
      {{ data?.title || 'Contact Us' }}
    </h2>
    <p class="contact-subtitle"
       [style.color]="paragraphColor || '#555963'"
       [style.font-family]="bodyFont || 'Inter, sans-serif'">
      {{ data?.subtitle || '' }}
    </p>
  </div>
  
  <div class="contact-content">
    <!-- Map Section -->
    <div class="contact-map">
      <!-- Map embed URL (iframe) -->
      <iframe 
        *ngIf="getMapEmbedUrl()"
        [src]="getMapEmbedUrl()"
        class="map-iframe"
        frameborder="0"
        style="border:0"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
      <!-- Fallback: Map image -->
      <img 
        *ngIf="!getMapEmbedUrl() && data?.mapImage" 
        [src]="data?.mapImage" 
        [alt]="data?.mapAlt || 'Map location'" 
        class="map-image">
      <!-- Fallback: Placeholder -->
      <div *ngIf="!getMapEmbedUrl() && !data?.mapImage" class="map-placeholder">
        <div class="map-placeholder-content">
          <div class="map-pin-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="#EF4444"/>
            </svg>
          </div>
        </div>
      </div>
      <!-- Map Pin Marker -->
      <div class="map-pin">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" fill="#FFFFFF"/>
          <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="#EF4444"/>
        </svg>
      </div>
    </div>
    
    <!-- Contact Info Section -->
    <div class="contact-info-section">
      <!-- Divider Line -->
      <div class="info-divider"></div>
      
      <!-- Location, Contact, Email Row -->
      <div class="contact-info-row">
        <div class="info-item" *ngIf="data?.address">
          <h3 [style.color]="headingColor || '#555963'"
              [style.font-family]="headingFont || 'Inter, sans-serif'">LOCATION</h3>
          <p [style.color]="paragraphColor || '#555963'"
             [style.font-family]="bodyFont || 'Inter, sans-serif'">{{ data?.address }}</p>
        </div>
        <div class="info-divider-vertical"></div>
        <div class="info-item" *ngIf="data?.phone">
          <h3 [style.color]="headingColor || '#555963'"
              [style.font-family]="headingFont || 'Inter, sans-serif'">CONTACT</h3>
          <p [style.color]="paragraphColor || '#555963'"
             [style.font-family]="bodyFont || 'Inter, sans-serif'">{{ data?.phone }}</p>
        </div>
        <div class="info-divider-vertical"></div>
        <div class="info-item" *ngIf="data?.email">
          <h3 [style.color]="headingColor || '#555963'"
              [style.font-family]="headingFont || 'Inter, sans-serif'">EMAIL</h3>
          <p [style.color]="paragraphColor || '#555963'"
             [style.font-family]="bodyFont || 'Inter, sans-serif'">{{ data?.email }}</p>
        </div>
      </div>
      
      <!-- Divider Line -->
      <div class="info-divider"></div>
      
      <!-- Operating Hours Section -->
      <div class="operating-hours-section" *ngIf="hasBusinessHours()">
        <h3 class="operating-hours-title"
            [style.color]="headingColor || '#555963'"
            [style.font-family]="headingFont || 'Inter, sans-serif'">OPERATING HOURS</h3>
        <div class="hours-row">
          <p *ngFor="let hours of data?.businessHours; trackBy: trackByIndex" 
             class="hours-item"
             [style.color]="paragraphColor || '#555963'"
             [style.font-family]="bodyFont || 'Inter, sans-serif'">
            <span *ngIf="hours.days">{{ hours.days }}</span>
            <span *ngIf="hours.day && !hours.days">{{ hours.day }}</span>
            <span *ngIf="(hours.days || hours.day) && (hours.time || hours.openTime)">: </span>
            <span *ngIf="hours.time">{{ hours.time }}</span>
            <span *ngIf="hours.openTime && !hours.time && !hours.closed">{{ hours.openTime }}</span>
            <span *ngIf="hours.closed">Closed</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

